export enum PeriodType {
  Quarter = 'quarter',
  Overtime = 'overtime',
}

export const PERIOD_TYPE_LABELS = new Map<PeriodType, string>([
  [PeriodType.Quarter, 'QTR'],
  [PeriodType.Overtime, 'OT'],
])

export const MAX_PERIODS: number = 4
